import { useMemo } from 'react';
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';
import { getDemoServicesForBusiness } from '../utils/demoData';

const DEMO_BUSINESS_IDS = ['9001', '9002', '9003'];

export const useInventory = () => {
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const { userRole } = useAuthStore();

  const isDemo = DEMO_BUSINESS_IDS.includes(String(activeBusinessId));
  const isReadOnlyDemo = isDemo && userRole !== 'master';

  const rawBusiness = useMemo(() => {
    if (!Array.isArray(masterDb)) return null;
    return masterDb.find(b => String(b.id) === String(activeBusinessId)) || null;
  }, [masterDb, activeBusinessId]);

  const activeBusiness = useMemo(() => {
    if (!rawBusiness) return null;
    const rawServices = Array.isArray(rawBusiness.services) ? rawBusiness.services : [];
    const finalServices = rawServices.length > 0 ? rawServices : (isDemo ? getDemoServicesForBusiness(activeBusinessId) : []);

    return {
      ...rawBusiness,
      services: finalServices
    };
  }, [rawBusiness, isDemo, activeBusinessId]);

  const updateBusiness = (updatedBusiness) => {
    setMasterDb(prev => {
      if (!Array.isArray(prev)) return prev;
      return prev.map(b => {
        if (String(b.id) === String(updatedBusiness.id)) {
          return { ...b, ...updatedBusiness };
        }
        return b;
      });
    });
  };

  return {
    activeBusiness,
    updateBusiness,
    isReadOnlyDemo,
    isDemo
  };
};
